
import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GenericFieldButtonNextBackComponent } from '../core.components/generic-button/generic-field-button-next-back.component';
import { PipeCurrencyEuro } from '../core.utilidades/pipeEuro';
import { PipeCurrencyEuroSinDecimales } from '../core.utilidades/pipeEuroSinDecimales';

@NgModule({
    declarations: [

        PipeCurrencyEuro,
        PipeCurrencyEuroSinDecimales,
        GenericFieldButtonNextBackComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        { provide: LOCALE_ID, useValue: 'es' },
        PipeCurrencyEuroSinDecimales,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        RouterModule,
        TranslateModule,

        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatDialogModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        TranslateModule,

        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatDialogModule,

        PipeCurrencyEuro,
        PipeCurrencyEuroSinDecimales,
        GenericFieldButtonNextBackComponent,

    ]
})

export class ModuloComunModule { }
